import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import classnames from 'classnames'
import { browserHistory } from 'react-router'

import { reset } from '_modules/user/actions'
import ReactPasswordStrength from '_components/passwordStrengthInput'

import styles from './styles.css'

const mapDispatchToProps = {
  reset,
}

class ResetPassword extends PureComponent {
  static propTypes = {
    reset: PropTypes.func.isRequired,
  }

  static defaultProps = {}

  state = {
    token: null,
    password: '',
  }

  componentWillMount() {
    this.setState({
      token: this.props.location.query.token ? this.props.location.query.token : null,
    })
  }

  onChangePassword = info => {
    const { score, isValid, password } = info
    this.setState({
      password,
    })
  }

  onSubmit = event => {
    event.preventDefault()
    const { password, token } = this.state

    if (!password) {
      return
    }

    const payload = {
      token,
      password,
    }

    this.props.reset(payload)

    browserHistory.push('/login')
  }

  render() {
    const { password } = this.state
    return (
      <form onSubmit={this.onSubmit} className={classnames(styles.main, styles.Grid)}>
        <div className={classnames(styles['Grid-cell'], styles['u-size1of1'], styles['page-name'])}>
          Reset Password
        </div>
        <div style={{ margin: 20 }} />
        <ReactPasswordStrength
          className={classnames(styles['Grid-cell'], styles['u-size1of1'])}
          id="password"
          minLength={8}
          minScore={2}
          scoreWords={['weak', 'okay', 'good', 'strong', 'stronger']}
          changeCallback={this.onChangePassword}
        />
        <div style={{ margin: 20 }} />
        <div className={classnames(styles['Grid-cell'], styles['u-size1of1'])}>
          <button type="submit" onClick={this.onSubmit}>
            SUBMIT
          </button>
        </div>
      </form>
    )
  }
}

export default connect(
  null,
  mapDispatchToProps
)(ResetPassword)



// WEBPACK FOOTER //
// ./src/views/reset-password/index.js